import * as i0 from '@angular/core';
import { inject, Injectable, NgModule } from '@angular/core';
import { CART_NORMALIZER } from '@spartacus/cart/base/root';
import * as i2 from '@spartacus/core';
import { LoggerService, normalizeHttpError, backOff, isJaloError, OCC_HTTP_TOKEN, provideDefaultConfig } from '@spartacus/core';
import { catchError, map } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { HttpContext } from '@angular/common/http';
import { CHECKOUT_PAYMENT_TYPE_NORMALIZER, CheckoutPaymentTypeAdapter, CheckoutCostCenterAdapter } from '@spartacus/checkout/b2b/core';
import { CommonModule } from '@angular/common';
let OccCheckoutCostCenterAdapter = /*#__PURE__*/(() => {
  class OccCheckoutCostCenterAdapter {
    constructor(http, occEndpoints, converter) {
      this.http = http;
      this.occEndpoints = occEndpoints;
      this.converter = converter;
      this.logger = inject(LoggerService);
    }
    setCostCenter(userId, cartId, costCenterId) {
      return this.http.put(this.getSetCartCostCenterEndpoint(userId, cartId, costCenterId), {}).pipe(catchError(error => {
        throw normalizeHttpError(error, this.logger);
      }), backOff({
        shouldRetry: isJaloError
      }), this.converter.pipeable(CART_NORMALIZER));
    }
    getSetCartCostCenterEndpoint(userId, cartId, costCenterId) {
      return this.occEndpoints.buildUrl('setCartCostCenter', {
        urlParams: {
          userId,
          cartId
        },
        queryParams: {
          costCenterId
        }
      });
    }
    static {
      this.ɵfac = function OccCheckoutCostCenterAdapter_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OccCheckoutCostCenterAdapter)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.OccEndpointsService), i0.ɵɵinject(i2.ConverterService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: OccCheckoutCostCenterAdapter,
        factory: OccCheckoutCostCenterAdapter.ɵfac
      });
    }
  }
  return OccCheckoutCostCenterAdapter;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let OccCheckoutPaymentTypeAdapter = /*#__PURE__*/(() => {
  class OccCheckoutPaymentTypeAdapter {
    constructor(http, occEndpoints, converter) {
      this.http = http;
      this.occEndpoints = occEndpoints;
      this.converter = converter;
      this.logger = inject(LoggerService);
    }
    getPaymentTypes() {
      const context = new HttpContext().set(OCC_HTTP_TOKEN, {
        sendUserIdAsHeader: true
      });
      return this.http.get(this.getPaymentTypesEndpoint(), {
        context
      }).pipe(catchError(error => {
        throw normalizeHttpError(error, this.logger);
      }), backOff({
        shouldRetry: isJaloError
      }), map(paymentTypeList => paymentTypeList.paymentTypes ?? []), this.converter.pipeableMany(CHECKOUT_PAYMENT_TYPE_NORMALIZER));
    }
    getPaymentTypesEndpoint() {
      return this.occEndpoints.buildUrl('paymentTypes');
    }
    setPaymentType(userId, cartId, paymentType, purchaseOrderNumber) {
      return this.http.put(this.getSetCartPaymentTypeEndpoint(userId, cartId, paymentType, purchaseOrderNumber), {}).pipe(catchError(error => {
        throw normalizeHttpError(error, this.logger);
      }), backOff({
        shouldRetry: isJaloError
      }), this.converter.pipeable(CART_NORMALIZER));
    }
    getSetCartPaymentTypeEndpoint(userId, cartId, paymentType, purchaseOrderNumber) {
      const queryParams = {
        paymentType,
        purchaseOrderNumber
      };
      return this.occEndpoints.buildUrl('setCartPaymentType', {
        urlParams: {
          userId,
          cartId
        },
        queryParams
      });
    }
    static {
      this.ɵfac = function OccCheckoutPaymentTypeAdapter_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || OccCheckoutPaymentTypeAdapter)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.OccEndpointsService), i0.ɵɵinject(i2.ConverterService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: OccCheckoutPaymentTypeAdapter,
        factory: OccCheckoutPaymentTypeAdapter.ɵfac
      });
    }
  }
  return OccCheckoutPaymentTypeAdapter;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultB2bCheckoutDetailsOccEndpoint = {
  getCheckoutDetails: 'users/${userId}/carts/${cartId}?fields=deliveryAddress(FULL),deliveryMode(FULL),paymentInfo(FULL),costCenter(FULL),purchaseOrderNumber,paymentType(FULL)'
};
const defaultOccCheckoutB2BConfig = {
  backend: {
    occ: {
      endpoints: {
        ...defaultB2bCheckoutDetailsOccEndpoint,
        setDeliveryAddress: 'orgUsers/${userId}/carts/${cartId}/addresses/delivery',
        paymentTypes: 'paymenttypes',
        setCartCostCenter: 'users/${userId}/carts/${cartId}/costcenter',
        setCartPaymentType: 'users/${userId}/carts/${cartId}/paymenttype'
      }
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutB2BOccModule = /*#__PURE__*/(() => {
  class CheckoutB2BOccModule {
    static {
      this.ɵfac = function CheckoutB2BOccModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutB2BOccModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CheckoutB2BOccModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig(defaultOccCheckoutB2BConfig), {
          provide: CheckoutPaymentTypeAdapter,
          useClass: OccCheckoutPaymentTypeAdapter
        }, {
          provide: CheckoutCostCenterAdapter,
          useClass: OccCheckoutCostCenterAdapter
        }],
        imports: [CommonModule]
      });
    }
  }
  return CheckoutB2BOccModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CheckoutB2BOccModule, OccCheckoutCostCenterAdapter, OccCheckoutPaymentTypeAdapter };
